import Storage from 'vue-ls';
const options = {
    namespace: 'LANGUAGEX__', // 添加前缀
    name: 'ls', // 默认 "ls"
    storage: 'local', // 存储方式：sessionStorage or localStorage
};

const { ls } = Storage.useStorage(options);
export default ls;